import { render, staticRenderFns } from "./VulnCodeBlockItem.vue?vue&type=template&id=a711c4ae&scoped=true"
import script from "./VulnCodeBlockItem.vue?vue&type=script&lang=js"
export * from "./VulnCodeBlockItem.vue?vue&type=script&lang=js"
import style0 from "./VulnCodeBlockItem.vue?vue&type=style&index=0&id=a711c4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a711c4ae",
  null
  
)

export default component.exports